export const HERO_CONSTANTS = {
  title: "The OneMind Cloud : Many in Body, One in Mind",
  desc: [
    {
      text: "We believe technology should feel natural—intelligent, secure, and seamlessly connected. At OneMind, our approach is inspired by the ancient Indian idea of Ekatma—a state of oneness between mind and consciousness.",
      highlight: ["OneMind", "Ekatma", "Oneness of", " Mind ", " Consciousness"],
    },
    {
      text: "Just as our ancestors envisioned a space where knowledge flowed freely (Chidakasha), we see the cloud as that modern space—limitless, aware, and deeply interconnected.",
      highlight: ["Chidakasha"],
    },
    {
      text: "That vision drives everything we do. From cloud automation and observability to cybersecurity and infrastructure design, we help businesses simplify complexity and move forward with clarity.",
      highlight: [
        "cloud automation",
        "observability",
        "cybersecurity",
        "infrastructure design",
      ],
    },
    {
      text: "OneMind isn’t just a name—it’s how we think, build, and deliver.",
      highlight: ["OneMind"],
    },
  ],
  btnText: "Talk To Our Experts Today",
};
